import jwt_decode from "jwt-decode";
// Set Token
export const setToken = (token) => {
  const TokenKey = localStorage.setItem("vue_token", token);
  return TokenKey;
};

// Remove Token
export const removeToken = () => {
  return localStorage.removeItem("vue_token");
};

export const getToken = () => {
  if (document.cookie.length > 0) {
    let data = document.cookie.split(";");
    for (let i in data) {
      let cur = data[i].split("=");
      if (cur[0].trim() === "accessToken") {
        return cur[1];
      }
    }
  }
  return null;
};

export const getRefreshToken = () => {
  if (document.cookie.length > 0) {
    let data = document.cookie.split(";");
    for (let i in data) {
      let cur = data[i].split("=");
      if (cur[0].trim() === "refreshToken") {
        return cur[1];
      }
    }
  }
  return null;
};

export const clearCookies = () => {
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie =
      // name.trim() + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;";
      name.trim() +
      "=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=hire3x.com;";
  }
};

export const checkAccess = () => {
  if (document.cookie.length > 0) {
    let data = document.cookie.split(";");
    for (let i in data) {
      let cur = data[i].split("=");
      if (cur[0].trim() === "candidate") {
        if (cur[1] === "no-access") {
          return false;
        } else {
          return true;
        }
      }
    }
  }
  return false;
};

export const checkTokenExpiry = () => {
  // let cookieToken = localStorage.getItem("vue_token");
  let cookieToken = getToken();
  let decoded = jwt_decode(cookieToken);
  let time = null;
  let currentTime = Math.floor(new Date().getTime());
  if (currentTime >= decoded.exp * 1000) {
    time = false;
  } else {
    time = true;
  }
  return time;
};
